export interface AccessDeniedProps {
  title: string

  detail: string
}

export function AccessDenied({ title, detail }: AccessDeniedProps) {
  return (
    <div className="canopy-page">
      <div className="canopy-page-header">
        <div>
          <h1 className="canopy-page-title">{title}</h1>
          <div className="canopy-page-sub">Not available for your role</div>
        </div>
      </div>
      <div className="canopy-card">
        <div className="canopy-card-title">Access denied</div>
        <div className="text-text-2 text-[12px] leading-relaxed">{detail}</div>
      </div>
    </div>
  )
}
